/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CampTripDto2 } from '../../models/camp-trip-dto-2';
import { CampTripShowResponse } from '../../models/camp-trip-show-response';

export interface PatchCampTripUpdate$Params {
  id: string;
      body: CampTripDto2
}

export function patchCampTripUpdate(http: HttpClient, rootUrl: string, params: PatchCampTripUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<CampTripShowResponse>> {
  const rb = new RequestBuilder(rootUrl, patchCampTripUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CampTripShowResponse>;
    })
  );
}

patchCampTripUpdate.PATH = '/v1/camp-trip/{id}';
